import React from 'react';
import { Route } from 'react-router';
export default (
    <Route path="admin"
      getComponent={(location, cb) => {
        require.ensure([], (require) => {
          cb(null, require('./index'));
        });
      }}
    >
      <Route
        path="orgimport"
        getComponent={(location, cb) => {
          require.ensure([], (require) => {
            cb(null, require('./OrgImport/'));
          });
        }}
      />
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyAdmin/router.js
 **/